import { CONTENTS } from '../graphql/queries/content';
import { useFetchItems } from './useFetchItems';
export const useContents = ({ skip = false, clientId, id, ids, contentType, extraData, includeInactive = false, }) => {
    const { items, error, loading, find, refetch } = useFetchItems({
        fetchQuery: CONTENTS,
        dataProp: 'contents',
        skip: skip || (!contentType && !id && !ids),
        spec: { clientId, id, ids, contentType, extraData, includeInactive },
    });
    return {
        contents: items || [],
        error,
        loading,
        find,
        refetch,
    };
};
